import React from "react";
export default class Marker extends React.PureComponent {
  render = () => (
    <div
      style={{
        position: "absolute",
        width: 40,
        height: 40,
        left: -40 / 2,
        top: -40 / 2,
        borderRadius: 40,
        textAlign: "center",
        color: "#3f51b5",
        fontSize: 16,
        fontWeight: "bold",
        padding: 4
      }}
      // {...this.props}
      className="map_marker"
    />
  );
}
